import genererGuid from '@/services/general/genererGuid';

export default function genererTypeFormatPresseLigne() {
  return {
    id: genererGuid(),
    largeur: 0,
    hauteur: 0,
    sens: '',
    emplacementId: '',
    surfaceId: '',
    couleurEncartId: '',
    isCreate: true,
  };
}
